import React, { useEffect, useState } from 'react'

import { useBannerNotificationService } from './useBannerNotificationService'

import { InitialBannerState } from './components'

export const NotificationBanner: React.FC = () => {
  const { 
    data, 
    isLoading, 
    isSuccess, 
    updatePhoneNotification,
  } = useBannerNotificationService()

  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    if (data === null) {
      setShowBanner(true)
    }
  }, [data])

  return (
    <>
      {showBanner
        ? (
          <InitialBannerState
            isLoading={isLoading}
            isSuccess={isSuccess}
            handleCloseBanner={() => setShowBanner(false)}
            handleUpdatePhoneNotification={updatePhoneNotification}
          />
        )
        : null
      }
    </>
  )
}